// components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Компонент защищенного маршрута
 * Проверяет аутентификацию и права доступа пользователя
 * 
 * @param {Object} props - Свойства компонента
 * @param {React.ReactNode} props.children - Дочерние компоненты
 * @param {string} [props.requiredRole] - Необходимая роль для доступа
 * @returns {JSX.Element} - Компонент для рендеринга
 */
const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Пока проверяем аутентификацию, показываем индикатор загрузки
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Если пользователь не аутентифицирован, перенаправляем на страницу входа
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если требуется определенная роль и у пользователя ее нет (и он не админ),
  // перенаправляем на страницу "Нет доступа"
  if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  // Если все проверки пройдены, отображаем защищенный контент
  return children;
};

export default ProtectedRoute;